import { Route, Routes } from 'react-router-dom';
import App from 'src/components/App';
import {
    BULK_GRANULAR_SLA_MANAGEMENT_PATH,
    GRANULAR_SLA_LANDING_PATH,
    GRANULAR_SLA_MANAGEMENT_PATH,
    ROOT_PATH,
    R2F_THRESHOLD_CONFIG_PATH,
    R2F_THRESHOLD_CONFIG_WITH_SITE_PATH,
    BULK_R2F_THRESHOLD_CONFIG_PATH,
    CORA_PATH,
    CORA_WITH_NODE_PATH
} from 'src/core/config/navigationRoutes';
import BulkProductionCapabilityManager from 'src/features/pages/granularSLA/BulkProductionCapabilityManager';
import GranularSLALandingPage from 'src/features/pages/granularSLA/GranularSLALandingPage';
import ProductionCapabilityManagerWithHierarchy from 'src/features/pages/granularSLA/ProductionCapabilityManagerWithHierarchy';
import LandingPage from 'src/features/pages/LandingPage';
import R2FThresholdManager from 'src/features/pages/r2fThresholds/R2FThresholdManager';
import BulkR2FManager from 'src/features/pages/r2fThresholds/BulkR2FManager';
import CORAPage from 'src/features/pages/cora/CORAPage';

const ApplicationRoutes = () =>
{
    return (
        <Routes>
            <Route path={ROOT_PATH} element={<App />}>
                <Route index element={<LandingPage />} />
                <Route path={GRANULAR_SLA_LANDING_PATH} element={<GranularSLALandingPage />}> </Route>
                <Route path={GRANULAR_SLA_MANAGEMENT_PATH} element={<ProductionCapabilityManagerWithHierarchy />} />
                <Route path={BULK_GRANULAR_SLA_MANAGEMENT_PATH} element={<BulkProductionCapabilityManager />} />
                <Route path={R2F_THRESHOLD_CONFIG_PATH} element={<R2FThresholdManager />} />
                <Route path={R2F_THRESHOLD_CONFIG_WITH_SITE_PATH} element={<R2FThresholdManager />} />
                <Route path={BULK_R2F_THRESHOLD_CONFIG_PATH} element={<BulkR2FManager />} />
                <Route path={CORA_PATH} element={<CORAPage />} />
                <Route path={CORA_WITH_NODE_PATH} element={<CORAPage />} />
            </Route>
        </Routes>
    );
};

export default ApplicationRoutes;
